/** @jsx jsx */
import * as React from "react";
import { css, InterpolationWithTheme, jsx } from "@emotion/core";
import { interventionsSummaryStyles } from "../../styles/Interventions/interventionsSummary";
import { IFetchScheduledInterventionsResponse, INTERVENTIONS_STATUS } from "../../models/IFetchScheduledInterventions";
import { interventionsHistoryStyles } from "../../styles/Interventions/interventionsHistory";
import { interventionsDailyViewStyles } from "../../styles/Interventions/interventionsDailyView";
import { ISugarJournalResponse } from "../../models/ISugarJournalResponse";
import Select, { OptionsType } from "react-select";
import { FilterSelect } from "./FilterSelect";
import { Card } from "../common/Card";


interface ISugarJournalProps {
    data: Array<ISugarJournalResponse>;
}

interface ISugarJournalState {
    hoverIndex: number;
    sortBy: "STARTDATE" | "ENDDATE";
    orderBy: "ASC" | "DES",
    paginationStartIndex: number
}





export class SugarJournalTable extends React.Component<ISugarJournalProps, ISugarJournalState> {
    constructor(props: ISugarJournalProps) {
        super(props);
        this.state = {
            hoverIndex: -1,
            sortBy: null,
            orderBy: null,
            paginationStartIndex: 0
        };
        this.setHoverIndex = this.setHoverIndex.bind(this);
        this.setSortStatus = this.setSortStatus.bind(this);
        this.getPaginatedData = this.getPaginatedData.bind(this);
        this.goToNextPage = this.goToNextPage.bind(this);
        this.goToPrevPage = this.goToPrevPage.bind(this);
    }

    setHoverIndex(index: number): void {
        if (this.state.hoverIndex === index) {
            this.setState({ hoverIndex: -1 });
        } else {
            this.setState({ hoverIndex: index });
        }
    }

    private setSortStatus(sortBySelected: "STARTDATE" | "ENDDATE"): void {
        const { sortBy, orderBy } = this.state;
        if (sortBySelected === sortBy) {
            this.setState({ orderBy: orderBy === "ASC" ? "DES" : "ASC" });
        } else {
            this.setState({ sortBy: sortBySelected, orderBy: "ASC" });
        }
    }

    private sortData(data: Array<ISugarJournalResponse>): Array<ISugarJournalResponse> {
        const { sortBy, orderBy } = this.state;
        // if (sortBy && orderBy && data && data.length > 0) {
        //     if (sortBy === "STARTDATE" && orderBy === "ASC") {
        //         data = data.sort((tableData1, tableData2) => tableData1.startDate - tableData2.startDate);
        //     } else if (sortBy === "STARTDATE" && orderBy === "DES") {
        //         data = data.sort((tableData1, tableData2) => tableData2.startDate - tableData1.startDate);
        //     } else if (sortBy === "ENDDATE" && orderBy === "ASC") {
        //         data = data.sort((tableData1, tableData2) => tableData1.endDate - tableData2.endDate);
        //     } else if (sortBy === "ENDDATE" && orderBy === "DES") {
        //         data = data.sort((tableData1, tableData2) => tableData2.endDate - tableData1.endDate);
        //     }
        // }
        return data;
    }

    private getPaginatedData(data: Array<ISugarJournalResponse>): Array<ISugarJournalResponse> {
        const { paginationStartIndex } = this.state;
        if (data && data.length > 0) {
            data = data.splice(paginationStartIndex, 20);
        }
        return data;
    }

    private goToPrevPage(): void {
        let { paginationStartIndex } = this.state;
        const { data } = this.props;
        if (data.length > 0 && paginationStartIndex > 0) {
            paginationStartIndex--;
            this.setState({ paginationStartIndex });
        };
    }

    private goToNextPage(): void {
        const { data } = this.props;
        let { paginationStartIndex } = this.state;
        if (data.length > 0 && paginationStartIndex + 20 < data.length) {
            paginationStartIndex++;
            this.setState({ paginationStartIndex });
        };
    }

    filterChange() {

    }

    render() {
        let { data } = this.props;
        // data = this.getPaginatedData(data);
        // data = this.sortData(data);
        const { hoverIndex } = this.state;

        return (<div css={interventionsSummaryStyles.summaryCardWrapper}>
            <div>
                <div css={interventionsHistoryStyles.selectedTab}>Glucometer Readings</div>
            </div>
            <Card customCss={{ borderRadius: "0 10px 10px 10px" }} showShadow>
                <div css={{ ...interventionsSummaryStyles.summaryContainer as any, paddingLeft: 0, paddingRight: 0 }}>
                    {/* <div>
                        <span>Filters: </span>
                        <FilterSelect options=/>
                    </div> */}
                    <div>
                        <table css={interventionsHistoryStyles.table}>
                            <thead>
                                <tr css={interventionsHistoryStyles.tableHeader}>
                                    <td css={interventionsHistoryStyles.paddedTd} onClick={() => this.setSortStatus("STARTDATE")}>
                                        <div>
                                            <span> Date</span>
                                            <span css={interventionsHistoryStyles.caratStyles} className="glyphicon glyphicon-chevron-down"></span>
                                        </div>
                                    </td>
                                    <td css={interventionsHistoryStyles.paddedTd}>
                                        <div>Time Slot</div>
                                    </td>
                                    <td css={interventionsHistoryStyles.paddedTd}>
                                        <div>Reading</div>
                                    </td>
                                    <td css={interventionsHistoryStyles.paddedTd}>
                                        <div>Time</div>
                                    </td>
                                    <td css={interventionsHistoryStyles.paddedTd}>
                                        <div>Comment</div>
                                    </td>
                                </tr>
                            </thead>
                            <tbody css={interventionsHistoryStyles.tableBodyText}>
                                {/* <tr>
                                    <td colSpan={5}>
                                        <div css={interventionsDailyViewStyles.divider}></div>
                                    </td>
                                </tr> */}
                                {data && data.length > 0 && data.map(({ userMetricValue: { sourceMetadata, metricDate, value, metric: { unit } } }, idx) => {

                                    // const hoverCss: InterpolationWithTheme<any> = hoverIndex === idx ? { background: "pink", cursor: "pointer" } : {};
                                    // const hoverCss: InterpolationWithTheme<any> = { } };
                                    // const borderHoverStyle = { borderLeft: hoverIndex === idx ? "5px solid #ff316d" : "5px solid transparent" };
                                    //onMouseEnter={() => this.setHoverIndex(idx)} onMouseLeave={() => this.setHoverIndex(idx)}
                                    const trCss = {
                                        borderLeft: "5px solid transparent",
                                        cursor: "pointer",
                                        background: '#fff',
                                        borderTop: "1px solid #eee",
                                        ':nth-of-type(2n)': {
                                            background: "#f8f5f5"
                                        },
                                        ':hover': {
                                            background: "#fae6ee",
                                            borderLeft: "5px solid #ff316d"
                                        }

                                    }

                                    return (<tr key={idx} css={trCss} >
                                        <td css={{ ...interventionsHistoryStyles.paddedTd as any, paddingLeft: 30 }}>
                                            <div css={interventionsHistoryStyles.colData}>{new Date(metricDate).toLocaleDateString()}</div>
                                        </td>
                                        <td css={interventionsHistoryStyles.paddedTd}>
                                            <div css={interventionsHistoryStyles.colData}>{sourceMetadata && sourceMetadata.readingType}</div>
                                        </td>
                                        <td css={interventionsHistoryStyles.paddedTd}>
                                            <div css={interventionsHistoryStyles.colData}>{`${value} ${unit}`}</div>
                                        </td>
                                        <td css={interventionsHistoryStyles.paddedTd}>
                                            <div css={interventionsHistoryStyles.colData}>{new Date(metricDate).toLocaleTimeString()}</div>
                                        </td>
                                        <td css={interventionsHistoryStyles.paddedTd}>
                                            <div css={interventionsHistoryStyles.colData}>{sourceMetadata && sourceMetadata.readingComments}</div>
                                        </td>
                                    </tr>)
                                })

                                }
                                {
                                    data && data.length === 0 &&
                                    <tr>
                                        <td colSpan={5}>
                                            <div css={{ textAlign: "center", marginTop: 20 }}>No Data</div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {data && data.length > 0 &&
                    <div css={interventionsHistoryStyles.legendContainer}>
                        <div css={interventionsHistoryStyles.prevNextBtn} onClick={this.goToNextPage}>
                            <span className="glyphicon glyphicon-chevron-left"></span>
                            <span>Previous</span>
                        </div>
                        <div>{"1 - 10 of 30"}</div>
                        <div css={interventionsHistoryStyles.prevNextBtn} onClick={this.goToNextPage}>
                            <span>Next</span>
                            <span className="glyphicon glyphicon-chevron-right"></span>
                        </div>


                    </div>
                }
            </Card>
        </div>)
    }
}